export const convertPxToRem = content => {
  if (!content) return content;

  const baseSize = 192; // 与SCSS保持一致

  // 转换各种CSS属性的px单位为rem
  let convertedContent = content
    // 转换font-size
    .replace(/font-size:\s*(\d+(?:\.\d+)?)px/g, (match, px) => {
      const remValue = parseFloat(px) / baseSize;
      // console.log(`转换字体大小: ${px}px → ${remValue}rem`);
      return `font-size: ${remValue}rem`;
    })
    // 转换line-height (如果是px单位)
    .replace(/line-height:\s*(\d+(?:\.\d+)?)px/g, (match, px) => {
      const remValue = parseFloat(px) / baseSize;
      // console.log(`转换行高: ${px}px → ${remValue}rem`);
      return `line-height: ${remValue}rem`;
    })
    // 转换margin
    .replace(/margin:\s*(\d+(?:\.\d+)?)px/g, (match, px) => {
      const remValue = parseFloat(px) / baseSize;
      // console.log(`转换外边距: ${px}px → ${remValue}rem`);
      return `margin: ${remValue}rem`;
    })
    // 转换padding
    .replace(/padding:\s*(\d+(?:\.\d+)?)px/g, (match, px) => {
      const remValue = parseFloat(px) / baseSize;
      // console.log(`转换内边距: ${px}px → ${remValue}rem`);
      return `padding: ${remValue}rem`;
    })
    // 转换margin-top, margin-bottom等
    .replace(/margin-(top|bottom|left|right):\s*(\d+(?:\.\d+)?)px/g, (match, direction, px) => {
      const remValue = parseFloat(px) / baseSize;
      // console.log(`转换${direction}外边距: ${px}px → ${remValue}rem`);
      return `margin-${direction}: ${remValue}rem`;
    })
    // 转换padding-top, padding-bottom等
    .replace(/padding-(top|bottom|left|right):\s*(\d+(?:\.\d+)?)px/g, (match, direction, px) => {
      const remValue = parseFloat(px) / baseSize;
      // console.log(`转换${direction}内边距: ${px}px → ${remValue}rem`);
      return `padding-${direction}: ${remValue}rem`;
    });

  return convertedContent;
};
